import {Component, OnInit, DoCheck} from '@angular/core';
import {DjangoBaseUser, DjangoSessionAuthenticationService} from './shared/authorization/custom';
import {Observable} from 'rxjs/Observable';
import {CollectorService} from './collector/collector.service';
import {StaticService} from './consulta/static.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [CollectorService]
})
export class AppComponent implements OnInit, DoCheck {
  title = 'app';
  user$: Observable<DjangoBaseUser>;
  offers;
  collectors;

  entered = false;
  adminview = false;

  constructor(private auth: DjangoSessionAuthenticationService, private collector: CollectorService, private staticS: StaticService) {
    this.user$ =  this.auth.getUserLogged$();
    this.user$.subscribe(data => {
      if (data !== undefined) {
        this.offers = data['offers'];
      }
    });
  }
  ngOnInit() {
    this.auth.getUserLogged();
  }

  ngDoCheck() {
    if (this.adminview != this.staticS.getAdminView()){
      this.adminview = this.staticS.getAdminView();
    }
  }

  enter(){
    this.entered = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts